<template lang="html">
  <div class="cart-component" v-bind:class="{ 'disabled' : product.stock <= 1 }">
    <b-form @submit="onSubmit">
      <div class="col col-quantity">
        <a class="btn-quantity minus" @click="changeQuantity('minus')"><i class="fa-regular fa-minus"></i></a>
        <b-form-input
          v-model="form.quantity"
          type="number"
          @paste.prevent
          @keypress="isNumber($event)"
          required
        ></b-form-input>
        <a class="btn-quantity plus" @click="changeQuantity('plus')"><i class="fa-regular fa-plus"></i></a>
      </div>

      <div class="col col-button">
        <b-button type="submit" class="btn-more"><i class="fa-light fa-cart-shopping"></i> Agregar</b-button>
      </div>
    </b-form>

    <b-modal modal-class="modal-added-product"  size="lg" ref="modal-added-prod" hide-footer title="" centered>
      <div class="px-lg-5 py-4">
        <p>
          <div class="sweet-modal-icon sweet-modal-success animate">
            <span class="sweet-modal-line sweet-modal-tip animateSuccessTip"></span>
            <span class="sweet-modal-line sweet-modal-long animateSuccessLong"></span>
            <div class="sweet-modal-placeholder"></div>
            <div class="sweet-modal-fix"></div>
          </div>
        </p>
        <p class="mt-5" v-html="modal.msg">
          <!-- El producto <strong>{{ product.name }}</strong> se agregado al carrito con 1 piezas -->
        </p>

        <p class="mt-3">
          <b-button class="btn btn-modal my-2 mx-2" slot="button" v-on:click.prevent="$refs['modal-added-prod'].hide()">Agregar mas productos</b-button>
          <b-button class="btn btn-modal my-2 mx-2" slot="button" v-on:click.prevent="$refs['modal-added-prod'].hide(); $router.push('/cart')">Ir al carrito <i class="color-white fas fa-shopping-cart"></i></b-button>
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ['product'],

  data() {
    return {
      form: {
        quantity: 1
      },

      modal:{
        msg:'',
        icon:'',
        block:false
      },
    }
  },

  methods: {
    changeQuantity(a) {
      if(a == 'minus') {
        if(this.form.quantity > 1) {
          this.form.quantity--;
        }
      }
      else {
        this.form.quantity++;
      }
    },

    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      let letterCount = (this.form.quantity.toString()).replace(/\s+/g, '').length;

      if(letterCount <= 9) {
        // Permitir solo un punto
        // if ( charCode === 46 && (this.amount.indexOf('.') == this.amount.lastIndexOf('.')) ) {
        //   evt.preventDefault();
        // }
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57)
          // && charCode !== 46
        ) {
          evt.preventDefault();
        }
      } else {
        evt.preventDefault();
      }
    },

    onSubmit(event) {
      event.preventDefault();

      if(this.product.stock >= 1) {
        var cart = [];
        var encontrado = false;

        if(this.form.quantity > 0){
          if(localStorage.cart){
            cart = JSON.parse(localStorage.getItem('cart'));

            for(var i = 0; i < cart.length ; i++){
              if(cart[i].id == this.product.id){
                var suma = Number(cart[i].quantity) + Number(this.form.quantity);
                cart[i].quantity = suma <= this.product.stock ? suma : this.product.stock;
                encontrado = true;
                break;
              }
            }

            if(!encontrado){
              cart.push({ id: this.product.id, quantity: this.form.quantity });
            }
          } else{
            cart.push({ id: this.product.id, quantity: this.form.quantity });
          }

          localStorage.setItem("cart",JSON.stringify(cart));
          this.$root.cartCount = cart.length;
          this.modal.msg = 'El producto <b>'+this.product.name+'</b> se agregado al carrito con '+this.form.quantity+' piezas';
          this.$refs['modal-added-prod'].show();
          // this.modal.icon = 'success';
          // this.$refs.modal.open();
        }
      }      
    },
  },
}
</script>
